<template>
  <div class="ipo-fee-block">
    <div class="ipo-fee-row">
      <span>{{ $t('ipo.unit_price') }}</span>
      <span>{{ fmt(unitPrice) }}</span>
    </div>
    <div class="ipo-fee-row">
      <span>{{ $t('ipo.order_amount') }}</span>
      <span>{{ fmt(total) }}</span>
    </div>
    <div class="ipo-fee-row">
      <span>{{ $t('ipo.commission') }}</span>
      <span>{{ fee }}%</span>
    </div>
    <div class="ipo-fee-row">
      <span>{{ $t('ipo.commission_amount') }}</span>
      <span>{{ fmt(feeAmount) }}</span>
    </div>
    <div class="ipo-fee-row ipo-fee-row--total">
      <span>{{ $t('ipo.total_amount') }}</span>
      <span>{{ fmt(totalWithFee) }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'IpoFeeCalculator',
  props: {
    fee: { type: Number, required: true },
    total: { type: Number, required: true },
  },
  computed: {
    ...mapGetters('ipoOrder', ['selectedIpo']),
    unitPrice() {
      return this.selectedIpo?.detail?.unit_price ?? 0
    },
    feeAmount() {
      return parseFloat(this.total) * parseFloat(this.fee) / 100
    },
    totalWithFee() {
      const val = this.feeAmount + parseFloat(this.total)
      this.$store.dispatch('ipoOrder/updateIncludedFee', val)
      return val
    },
  },
  methods: {
    fmt(val) {
      const code = this.selectedIpo?.currency_code
      if (!code || code === 'MNT') return '₮ ' + new Intl.NumberFormat().format(val ?? 0)
      return new Intl.NumberFormat('mn-MN', { style: 'currency', currency: code }).format(val ?? 0)
    },
  },
}
</script>
